<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-2">
    &nbsp; Products<div class="export_csv"
                        style="margin-bottom: 5px !important;">
      <!-- <div class="add_button_text">
          <button class="add_button_new pull-right" mat-raised-button (click)="formPage()"
              style="color:#295fc2">Share a News Update
          </button>
      </div>&nbsp;&nbsp; -->
      <button class="clear_button_export" style="float: right;" (click)="openDialogexport()" mat-raised-button
              color="primary">
        Export
      </button>
    </div>
  </div>

  <div class="page__content shadow p-3 ">
    <div>
      <br />
      <div>
        <table class="firstTable">
          <tr>
            <th class="FirstTh">Posts created till date</th>
            <th class="FirstTh">Posts created this month</th>
            <th class="FirstTh">Posts created previous month</th>
          </tr>
          <tr style="height:50px">
            <td class="FirstTd">{{avgData?.postedTillDate == null? 0 : avgData?.postedTillDate}}</td>
            <td class="FirstTd">{{avgData?.postedCurrentMonth == null? 0 : avgData?.postedCurrentMonth}}</td>
            <td class="FirstTd">{{avgData?.postedPreviousMonth == null? 0 : avgData?.postedPreviousMonth}}</td>
          </tr>
        </table>
      </div>

      <mat-card>
        <div class="example-header">
          <mat-form-field class="full-width-field" style="width: 50% !important;">
            <input matInput [(ngModel)]="searchData" (change)="changeFn($event)" placeholder="Search">

          </mat-form-field>&nbsp;
          <button type="submit" (click)="applyfilter(true)" class="btn btn-primary mat-primary search_bar">
            <mat-icon class="search_bar_icon">search</mat-icon>
          </button>
          <hr>

          <mat-form-field (click)="suche()">
            <mat-select [formControl]="bankMultiCtrl" [(ngModel)]="statedata" ngDefaultControl
                        placeholder="States" [multiple]="true" #multiSelect
                        noEntriesFoundLabel="'no matching country found'">
              <mat-option>
                <ngx-mat-select-search id="search1" [showToggleAllCheckbox]="true"
                                       (ngModelChange)="filterMyOptions($event);notFound()"
                                       [toggleAllCheckboxIndeterminate]="isIndeterminate"
                                       [toggleAllCheckboxChecked]="isChecked" (toggleAll)="toggleSelectAll($event)"
                                       [formControl]="bankMultiFilterCtrl"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let bank of filteredBanksMulti | async" [value]="bank">
                {{bank.stateName}}
              </mat-option>
            </mat-select>
          </mat-form-field>&nbsp;&nbsp;

          <mat-form-field (click)="sucheDistrict()">
            <mat-select [formControl]="districtMultiCtrl" [(ngModel)]="districtdata" ngDefaultControl
                        placeholder="Districts" [multiple]="true" #multiSelect>
              <mat-option>
                <ngx-mat-select-search id="search1" [showToggleAllCheckbox]="true"
                                       [toggleAllCheckboxIndeterminate]="isIndeterminateDistrict"
                                       [toggleAllCheckboxChecked]="isCheckedDistrict"
                                       (toggleAll)="toggleSelectAlldistrict($event)"
                                       [formControl]="districtMultiFilterCtrl" (ngModelChange)="notFoundDistrict()">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let district of selectDistrict" [value]="district">
                {{district}}
              </mat-option>
            </mat-select>
          </mat-form-field>&nbsp;&nbsp;

          <mat-form-field>
            <mat-label>Type</mat-label>
            <mat-select [(ngModel)]="productTypeName">
              <mat-option *ngFor="let type of productTypeList" [value]="type">
                {{type}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Variety</mat-label>
            <mat-select [(ngModel)]="varietyName">
              <mat-option *ngFor="let variety of varietyList[productTypeName]" [value]="variety">
                {{variety}}
              </mat-option>
            </mat-select>
          </mat-form-field>&nbsp;&nbsp;

          <mat-form-field>
            <mat-label>Status</mat-label>
                        <mat-select [(ngModel)]="statusdata" >
                            <mat-option *ngFor="let type of statusList" [value]="type.viewValue">
                                {{type.viewValue}}
                            </mat-option>
                        </mat-select>
          </mat-form-field>&nbsp;

          <!-- <button mat-raised-button (click)="open()">ok</button> -->
          <mat-form-field>
            <input matInput placeholder="Quantity" (click)="open()" [(ngModel)]="quantity">
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="Price" (click)="openPriceDialog()" [(ngModel)]="priceValue">
          </mat-form-field>&nbsp;&nbsp;

          <mat-form-field>
            <input matInput type="text" name="daterange" placeholder="Date Range" [min]="minDate"
                   [locale]="{applyLabel: 'ok', format: 'DD/MM/YYYY'}" autocomplete="off" [max]="maxDate"
                   [alwaysShowCalendars]="true" ngxDaterangepickerMd [(ngModel)]="sharedate"
                   [showCustomRangeLabel]="true" [ranges]="ranges"
                   (change)="onDateRangeChanged(sharedate)" />
          </mat-form-field>

          <button class="btn btn-primary mat-primary clear_button pull-right" style="margin-top: 12px;"
                  (click)="clearFilter()">
            Clear Filter
          </button>
          <button type="submit" style="margin-top: 12px; margin-right: 10px;" (click)="applyfilter(true)"
                  class="btn btn-primary mat-primary pull-right">
            Apply Filter
          </button>

          <mat-chip-list #chipList aria-label="Filter selection">
            <mat-chip *ngFor="let filter of matChipArray;let i=index" [selectable]="selectable"
                      [removable]="removable" (removed)="remove(i,filter.tag)">
              {{filter.name}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
          <div class="text_filter_data" *ngIf="exportcsvdata">
            <p *ngIf="this.length == 0">
              There's no record found with the given criteria, please
              try again refining your search and filters
            </p>
          </div>
        </div>
      </mat-card>
      <!-- new code for horizontal scroll -->
      <div class="example-container mat-elevation-z8" style="margin-top: 15px">
        <mat-table #table [dataSource]="dataSource" matSort>

          <ng-container matColumnDef="postedDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Posted </mat-header-cell>
            <mat-cell *matCellDef="let productData" class="userNameCol">
              <span> {{productData.postedDate}}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Type </mat-header-cell>
            <mat-cell *matCellDef="let productData" class="userNameCol">
              <span style="width: 118px;">{{productData.type}}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="farmerName">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Farmer </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              <a title="View Profile" class="user_profile"
                 (click)="openDialog(productData)">{{productData.farmerName}}</a>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="quantity">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Quantity </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{ productData.quantity}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="location">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Location </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.location}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="geoLocation">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Geo Location</mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.geoLocation}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="maxPrice">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Max Price </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.maxPrice}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="minPrice">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Min Price </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.minPrice}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="availableDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Available </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.availableDate}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.status}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="tradeInterest">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Trade Interest </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.tradeInterest}}
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
      </div>
      <div>
        <mat-paginator [length]="length" [pageIndex]="pageIndex" (page)="getServerData($event)"
                       [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="" class="pagination">
        </mat-paginator>
      </div>
      <!-- end of new code for horizontal scroll -->

      <!-- <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">
        <mat-table #table [dataSource]="dataSource" matSort>

          <ng-container matColumnDef="postedDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Posted </mat-header-cell>
            <mat-cell *matCellDef="let productData" class="userNameCol">
              <span> {{productData.postedDate}}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Type </mat-header-cell>
            <mat-cell *matCellDef="let productData" class="userNameCol">
              <span style="width: 118px;">{{productData.type}}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="farmerName">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Farmer </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              <a title="View Profile" class="user_profile"
                 (click)="openDialog(productData)">{{productData.farmerName}}</a>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="quantity">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Quantity </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{ productData.quantity}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="location">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Location </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.location}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="geoLocation">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Geo Location</mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.geoLocation}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="maxPrice">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Max Price </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.maxPrice}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="minPrice">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Min Price </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.minPrice}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="availableDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Available </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.availableDate}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.status}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="tradeInterest">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Trade Interest </mat-header-cell>
            <mat-cell *matCellDef="let productData">
              {{productData.tradeInterest}}
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

        <div>
          <mat-paginator [length]="length" [pageIndex]="pageIndex" (page)="getServerData($event)"
                         [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="" class="pagination">
          </mat-paginator>
        </div>
      </div> -->

    </div>
  </div>
</div>

